/** `jumbo.com` from ` https://www.Jumbo.com/nl/winkels?x=1 `; null when it is not a hostname. */
export const normaliseDomain = (input: string): string | null => {
  const trimmed = input.trim().toLowerCase();

  if (!trimmed) return null;

  let host = trimmed.replace(/^[a-z]+:\/\//, '');

  [host] = host.split(/[/?#]/);
  host = host.replace(/^www\./, '').replace(/\.$/, '');

  const isHostname = /^(?!-)(?:[a-z0-9-]{1,63}\.)+[a-z]{2,}$/.test(host) && host.length <= 253;

  return isHostname ? host : null;
};

const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Any real mailbox is allowed. The address only has to look like an email. */
export const isWorkEmail = (email: string) => EMAIL_SHAPE.test(email.trim());
